import { render, staticRenderFns } from "./TableroLavadero.vue?vue&type=template&id=6b4a3258&scoped=true"
import script from "./TableroLavadero.vue?vue&type=script&lang=js"
export * from "./TableroLavadero.vue?vue&type=script&lang=js"
import style0 from "./TableroLavadero.vue?vue&type=style&index=0&id=6b4a3258&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4a3258",
  null
  
)

export default component.exports